module.exports = __webpack_public_path__ + "img/4_04.76465ec9.png";